import { translationNotFound_da } from "./translationNotFound.da";
import { defineDashboardTranslations } from "./translationTypes";
import { translationNotFound_en } from "./translationNotFound.en";
import { translationNotFound_sv } from "./translationNotFound.sv";

export const translationNotFound = defineDashboardTranslations({
  da: translationNotFound_da,
  en: translationNotFound_en,
  sv: translationNotFound_sv,
});
